import { render, staticRenderFns } from "./TeacherAccountForm.vue?vue&type=template&id=62b8c294&scoped=true"
import script from "./TeacherAccountForm.vue?vue&type=script&lang=js"
export * from "./TeacherAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b8c294",
  null
  
)

export default component.exports